<template>
  <div class="v-view table-view a-fadeIn" :style="{ height: span * 33.33 + '%' }">
    <div class="v-title">{{ title }}</div>
    <img class="v-switch" src="../assets/images/icon_switch.png" alt="#" @click="showTable = !showTable" />
    <div class="tv-header">
      <span class="tv-header-item" v-for="item in deviceList" :key="item.type">
        <span class="tv-header-item__name">{{ item.name }}</span>
        <span class="tv-header-item__value" :class="item.type">{{ item.value }}</span>
      </span>
    </div>

    <transition name="fade" enter-active-class="a-fadeIn">
      <table v-if="showTable" class="tv-table">
        <thead class="tv-table-head" align="center">
          <tr>
            <th v-for="(item, index) in tableHead" :key="index">
              {{ item }}
            </th>
          </tr>
        </thead>

        <tbody v-if="tableList.length > 0" ref="table" class="tv-table-body" align="center">
          <tr v-for="item in tableList" :key="item.id">
            <td class="td-time">{{ item.time }}</td>
            <td class="td-organ">{{ item.organ }}</td>
            <td class="td-type">
              <img src="../assets/images/icon_smog.png" alt="#" />
              <span>{{ item.type }}</span>
            </td>
            <td v-if="item.status === '正常'" class="td-status td-status--normal">
              <img src="../assets/images/icon_normal.png" alt="#" />
              <span>正常</span>
            </td>
            <td v-else-if="item.status === '报警'" class="td-status td-status--alarm">
              <img src="../assets/images/icon_alarm.png" alt="#" />
              <span>报警</span>
            </td>
            <td v-else class="td-status td-status--fault">
              <img src="../assets/images/icon_fault.png" alt="#" />
              <span>故障</span>
            </td>
          </tr>
        </tbody>
        <tbody v-else class="tv-table-nodata">
          <tr>
            <td colspan="5">暂无数据!</td>
          </tr>
        </tbody>
      </table>
      <div v-else class="tv-chart">
        <v-chart
          v-if="chartData.length > 0"
          ref="chart"
          :options="chartOption"
          @mouseover="onMouseOver"
          @globalout="onGlobalOut"
          autoresize
        ></v-chart>
        <div v-else class="tv-chart-nodata">暂无数据!</div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { extractDayTime } from '@/utils'

export default {
  name: 'FireAlarm',
  computed: {
    ...mapGetters(['cid']),
  },
  props: {
    span: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: '消防报警信息',
    },
  },
  watch: {
    showTable(bool) {
      if (bool) {
        this.$nextTick(() => {
          !this.tableInterval && this.startAnimation('table')
        })
      } else {
        if (this.tableInterval) {
          clearInterval(this.tableInterval)
          this.tableInterval = null
        }
      }
    },
    chartData(data) {
      this.chartOption.dataset.source = data
    },
    tableData(newData, oldData) {
      const newItem = newData.length && newData[0]
      const oldItem = oldData.length && oldData[0]
      if (!oldItem || newItem.ID !== oldItem.ID) {
        this.tableList = newData.map((item) => ({
          id: item.ID,
          organ: item.AlertName,
          type: item.AlertType,
          status: item.AlertState,
          time: extractDayTime(item.AlertTime),
        }))
        this.$nextTick(() => {
          !this.tableInterval && this.startAnimation('table')
        })
      }
    },
  },
  data() {
    return {
      showTable: true,
      dataInterval: null,
      tableInterval: null,
      deviceList: [
        {
          type: 'total',
          name: '烟感',
          value: '-',
        },
        {
          type: 'online',
          name: '在线',
          value: '-',
        },
        {
          type: 'offline',
          name: '离线',
          value: '-',
        },
      ],
      tableHead: ['时间', '机构', '类型', '状态'],
      tableData: [],
      tableList: [],
      chartInterval: null,
      chartIndex: -1,
      chartData: [],
      chartColors: ['#004be3', '#e36b00', '#00e370', '#00afe3', '#e3db00'],
      chartOption: {
        grid: {
          top: '8%',
          left: '3%',
          right: '3%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          axisLine: {
            lineStyle: {
              color: '#fff',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            interval: 0,
            color: '#fff',
            fontSize: 14,
          },
          splitLine: {
            show: false,
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#fff',
            },
          },
          axisLabel: {
            color: '#fff',
            fontSize: 12,
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#fff',
              opacity: 0.1,
            },
          },
        },
        legend: {
          show: false,
        },
        tooltip: {
          show: true,
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        dataset: {
          dimension: ['name', 'value'],
          source: [],
        },
        series: [
          {
            type: 'bar',
            name: '消防报警统计',
            barMaxWidth: 20,
            itemStyle: {
              color: (params) => {
                return this.chartColors[params.dataIndex]
              },
            },
            encode: {
              x: 'name',
              y: 'value',
            },
          },
        ],
      },
    }
  },
  created() {
    this.getFireAlarmData()
    this.getFireDeviceData()
    this.getFireStatisData()
  },
  mounted() {
    this.dataInterval = setInterval(() => {
      this.getFireAlarmData()
    }, this.$interval)
  },
  beforeDestroy() {
    if (this.dataInterval) {
      clearInterval(this.dataInterval)
      this.dataInterval = null
    }
    if (this.tableInterval) {
      clearInterval(this.tableInterval)
      this.tableInterval = null
    }
    if (this.chartInterval) {
      clearInterval(this.chartInterval)
      this.chartInterval = null
    }
  },
  methods: {
    onMouseOver() {
      if (this.chartInterval) {
        clearInterval(this.chartInterval)
        this.chartInterval = null
      }
    },
    onGlobalOut() {
      !this.chartInterval && this.startAnimation('chart')
    },

    startAnimation(type) {
      if (type === 'table') {
        const node = this.$refs.table
        if (node && node.childNodes.length > 1) {
          this.tableInterval = setInterval(() => {
            const newChild = node.firstChild.cloneNode(true)
            newChild.classList.add('animated', 'fadeInUp')
            node.appendChild(newChild)
            node.removeChild(node.firstChild)
          }, 3000)
        }
      } else {
        const dataLen = this.chartData.length
        if (dataLen > 10) {
          this.chartInterval = setInterval(() => {
            if (this.chartIndex < dataLen - 11) {
              this.chartIndex++
            } else {
              this.chartIndex = 0
            }
            this.chart.dispatchAction({
              type: 'showTip',
              seriesIndex: 0,
              dataIndex: this.chartIndex,
            })
          }, 3000)
        }
      }
    },
    getFireAlarmData() {
      this.$api
        .getFireAlarmData(5)
        .then((res) => {
          if (!res || !res.length) return
          this.tableData = res
        })
        .catch((err) => {
          console.error(err)
        })
    },
    getFireDeviceData() {
      this.$api
        .getFireDeviceData()
        .then((res) => {
          if (!res) return
          this.deviceList = [
            {
              type: 'total',
              name: '烟感',
              value: res.DeviceAllCount,
            },
            {
              type: 'online',
              name: '在线',
              value: res.DeviceOnlineCount,
            },
            {
              type: 'offline',
              name: '离线',
              value: res.DeviceOfflineCount,
            },
          ]
        })
        .catch((err) => {
          console.error(err)
        })
    },
    getFireStatisData() {
      this.$api
        .getElderServiceStatis()
        .then((res) => {
          if (!res) return
          this.chartData = [
            {
              name: '人为',
              value: res.FireHumanResource,
            },
            {
              name: '误报',
              value: res.FireFalsePositive,
            },
            {
              name: '红外',
              value: res.FireInfraRed,
            },
            {
              name: '呼吸',
              value: res.FireBreath,
            },
            {
              name: '硬件故障',
              value: res.FireDeviceBroken,
            },
          ]
        })
        .catch((err) => {
          console.error(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.tv-header {
  display: flex;
  position: absolute;
  top: 1px;
  right: 50px;
  height: 5vh;

  &-item {
    display: inline-flex;
    align-items: center;
    font-size: 18px;

    + .tv-header-item {
      margin-left: 20px;
    }

    &__name {
      color: #fff;
      margin-right: 5px;
    }

    &__value {
      font-weight: 600;

      &.total {
        color: #006fcc;
      }
      &.online {
        color: #0ec560;
      }
      &.offline {
        color: #ff4810;
      }
    }
  }
}

.tv-table {
  td {
    > img {
      display: inline-block;
      vertical-align: middle;
      width: 20px;
      height: auto;
    }

    > span {
      display: inline-block;
      vertical-align: middle;
      margin-left: 5px;
    }
  }

  .td-time {
    color: #fa7310;
  }

  .td-organ,
  .td-type {
    color: #fff;
  }

  .td-status {
    &--normal {
      color: #0ec560;
    }
    &--alarm {
      color: #f00033;
    }
    &--fault {
      color: #ff7010;
    }
  }
}
</style>
